import { render, staticRenderFns } from "./ConfigTills.vue?vue&type=template&id=40af2df0&"
import script from "./ConfigTills.vue?vue&type=script&lang=js&"
export * from "./ConfigTills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports